var lx = lx || {};
lx.btn = lx.btn || {};

// Retain the shared legacy Orders callback; catalog workspaces own their enhancement.
lx.btn.catalog = function (value) {
    var parts = value.split('~');
    console.log(value);
    $.ajax({
        url:'wwv_flow.show', dataType:'html', traditional:true, cache:false, type:'POST',
        data:{
            p_flow_id:$v('pFlowId'), p_flow_step_id:$v('pFlowStepId'), p_instance:$v('pInstance'),
            p_request:'APPLICATION_PROCESS=getCatalogBtn', x01:parts[0], x02:parts[1]
        },
        success:function (html) { $('#ORDERS' + parts[0]).replaceWith(html); }
    });
};

lx.btn.hightlight = function (pId) {
    $("#" + pId).addClass("t-Button--hl");
	//$("#" + pId).removeClass("t-Button--primary");
};

lx.btn.unhightlight = function (pId) {
    $("#" + pId).removeClass("t-Button--hl");
	//$("#" + pId).addClass("t-Button--primary");
};

lx.btn.deleteHighlight = function (pBtn, pSelector) {
    var vSelector = "input[name='x02'],input[name='f01']";
    if (pSelector) vSelector = pSelector;
    $(vSelector).change(function (event) {
        hightlightButton(pBtn);
        event.stopPropagation();
    });
};

lx.btn.hightlightPopupLOV = function (pBtn,pPopupLOV,pUnhighlight = 'N') {
	$('#' + pPopupLOV).attr('onchange', 'lx.btn.hightlight("' + pBtn + '")');
	if (pUnhighlight == 'Y') {
		lx.btn.unhightlight(pBtn);
	}
};

/* this should be the same pkg_btn.basic_html 
eg. lx.btn.gen({"id":"switchBtn","label":"Switch","fa":"far fawe-random","js":"lx.nav.switch('+ row.id +');","class":"t-Button--link"})
    lx.btn.gen({"class":"t-Button--dd-noBorder","options":[{"label":"Delete","js":"lx.roster.shiftClearAll();"}]})
*/

lx.btn.gen = function (pBtn) {
    var lRet = '', lTag = 'nav';
	var lHideIcon = 'Y';
    if (pBtn.options) {
        for (let x = 0; x < pBtn.options.length; x++) {
            var btn = pBtn.options[x];
            lRet += '<li' + (btn.id ? ' id="' + btn.id + '"' : '')
                + (btn.class ? ' class="' + btn.class + '"' : '')
                + (btn.type == "G" ? ' class="lxBtnGroup"' : '')
                + (btn.style ? ' style="' + btn.style + ';"' : '')
                + (btn.title ? ' title="' + btn.title + '"' : '')
                + (btn.link ? '><a href="' + btn.link + '"' : (btn.js ? ' onclick="' + btn.js + '"' : ''))
                + '>' + btn.label + (btn.link ? '</a>' : '') + '</li>';
        }
        lRet = '<span class="t-Icon t-Icon--right far fawe-chevron-down"></span><ul>' + lRet + '</ul>';
    } else if (pBtn.link) {
        lTag = 'a';
    }
	
	if (pBtn.hideIcon == 'N') {
	  lHideIcon = pBtn.hideIcon;
	}
    lRet = '<' + lTag + ' class="t-Button' + (pBtn.class ? ' ' + pBtn.class : '') + 
          (pBtn.fa || pBtn.options ? ' t-Button--icon' : '') +
          (pBtn.fa ? ' t-Button--iconLeft' : '') +
          (pBtn.fa && lHideIcon == 'Y' ? ' t-Button--mobileHideLabel' : '') +
          (pBtn.options ? ' t-Button--dropdown  t-Button--icon t-Button--iconRight' : '') +
          '"'+
          (lTag == 'a' && pBtn.newWindow ? ' target="_blank"' : '')
        + (pBtn.id ? ' id="' + pBtn.id + '"' : '')
        + (pBtn.style ? ' style="' + pBtn.style + ';"' : '')
        + (pBtn.title ? ' title="' + pBtn.title + '"' : '')
        + (pBtn.link ? ' href="' + pBtn.link + '"' : (pBtn.js ? ' onclick="' + pBtn.js + '"' : ''))
        + '>'
        + (pBtn.fa ? '<span class="t-Icon t-Icon--left ' + pBtn.fa + '"></span>' : '')
        + (pBtn.label ? '<span class="t-Button-label">' + pBtn.label + '</span>' : '')
        + lRet + '</' + lTag + '>';
    return lRet;
};
lx.btn.genAll = function (pBtns){
    var lRet = '';
    for (let i = 0; i < pBtns.length; i++) {
        lRet += lx.btn.gen(pBtns[i]);
    }
    return lRet;
};

lx.btn.doc = function (pId) {
    var str = pId;
    var par = str.split('~');
    lx.load.add();
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getDocBtn",
            x01: par[1],
            x02: par[0]
        },
        success: function (d) {
            let $btn = $("#T" + par[1] + "I" + par[0]);
            let $par = $btn.parent('div');
            $btn.removeAttr('onmouseover').removeClass('lazy-Btn-Ir').find('ul').html( $(d).find('ul').html() );
            //console.log($par.find(".dotBtn"));
            lx.btn.ddToggle($par.find(".dotBtn"));
            lx.load.remove();

            //$("#T" + par[1] + "I" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.contact = function (pId, pThis) {
    var str = pId;
    var par = str.split('~');
    console.log(pThis);
    $(pThis).removeAttr('onmouseover');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getContactBtn",
            x01: par[0],
            x02: par[1],
            x03: par[2],
            x04: par[3]
        },
        success: function (d) {
			//console.log("SUCESS: "+par[0]);
            //$("#CONTACTS" + par[0]).replaceWith(d);
            $(pThis).find('ul').html( $(d).find('ul').html() );
        }
    });
};

// Catalog menu loading is owned by core/catalog-actions.js.

lx.btn.article = function (pId) {
    var str = pId;
    var par = str.split('~');
    lx.load.add();
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getArticleBtn",
            x01: par[0],
            x02: par[1],
            x03: par[2],
            x04: par[3],
            x05: par[4],
            x06: par[5],
            x07: par[6]
        },
        success: function (d) {
            //$("#" + par[0] + par[1]).replaceWith(d);

            let $btn = $("#" + par[0] + par[1]);
            let $par = $btn.parent('div');
            $btn.removeAttr('onmouseover').removeClass('lazy-Btn-Ir').find('ul').html( $(d).find('ul').html() );
            //console.log($par.find(".dotBtn"));
            lx.btn.ddToggle($par.find(".dotBtn"));
            lx.load.remove();
        }
    });
};

lx.btn.certification = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getCertificationBtn",
            x01: par[0]
        },
        success: function (d) {
            $("#CERTIFICATION" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.newsletter = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getNewsletterBtn",
            x01: par[0]
        },
        success: function (d) {
            $btn = $("#NEWSLETTER" + par[0]);
            //$btn.replaceWith(d);
            $btn.removeAttr('onmouseover').removeClass('lazy-Btn-Ir').find('ul').html( $(d).find('ul').html() );
        }
    });
};

lx.btn.survey = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getSurveyBtn",
            x01: par[0],
			x02: par[1],
			x03: par[2]
        },
        success: function (d) {
            $("#SURVEY" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.checklist = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getChecklistBtn",
            x01: par[0],
			x02: par[1]
        },
        success: function (d) {
            $("#CHECKLIST" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.checklistQuestion = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getChecklistQtnBtn",
            x01: par[0],
			x02: par[1]
        },
        success: function (d) {
            $("#CHECKLIST_QUESTION" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.roadmap = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getRoadmapBtn",
            x01: par[0]
        },
        success: function (d) {
            $("#ROADMAP" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.spareParts = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getSparePartsBtn",
            x01: par[0]
        },
        success: function (d) {
            $("#SPARE_PARTS" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.connections = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getConnectionBtn",
            x01: par[0]
        },
        success: function (d) {
            $("#CON" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.helpdesk = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getHelpdeskBtn",
            x01: par[0],
			x02: par[1],
			x03: par[2],
			x04: par[3]
        },
        success: function (d) {
            $('#'+ par[3] + par[0]).replaceWith(d);
        }
    });
};

lx.btn.orders = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getOrdersBtn",
            x01: par[0]         
        },
        success: function (d) {
            $("#WEBSTORE" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.subscription = function (pId) {
    var str = pId;
    var par = str.split('~');
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getSubscriptionBtn",
            x01: par[0],     
            x02: par[2]			
        },
        success: function (d) {
            $("#SUBSCRIPTION" + par[0]).replaceWith(d);
        }
    });
};

lx.btn.dmsSubject = function (pId) {
    var str = pId;
    var par = str.split('~');
    lx.load.add();
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v('pFlowStepId'),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getDmsSubjectBtn",
            x01: par[0],     
            x02: par[2]			
        },
        success: function (d) {
            let $btn = $("#DMS_SUB" + par[0]);
            let $par = $btn.parent('div');
            //console.log($btn);
            //$btn.replaceWith(d);
            $btn.removeAttr('onmouseover').removeClass('lazy-Btn-Ir').find('ul').html( $(d).find('ul').html() );
            //console.log($par.find(".dotBtn"));
            //lx.btn.ddToggle($par.find(".dotBtn"));
            lx.load.remove();
        }
    });
};

lx.btn.tree = function (pTreeId, pWhat, pWhere) {
    if (pWhere == "P") {
        $(pWhat).prepend("<a><img onclick=\"apex.widget.tree.collapse_all('" + pTreeId + "')\" style='cursor:pointer;vertical-align: bottom;padding: 0px 5px 2px 3px;' src='/i/social/img/icon_collapse_lxp.png'></a><a><img onclick=\"apex.widget.tree.expand_all('" + pTreeId + "')\" style='cursor:pointer;vertical-align: bottom;padding: 0px 5px 2px 0px;' src='/i/social/img/icon_expand_lxp.png'></a>");
    }
    if (pWhere == "A") {
        $(pWhat).append("<a><img onclick=\"apex.widget.tree.collapse_all('" + pTreeId + "')\" style='cursor:pointer;vertical-align: bottom;padding: 0px 5px 2px 3px;' src='/i/social/img/icon_collapse_lxp.png'></a><a><img onclick=\"apex.widget.tree.expand_all('" + pTreeId + "')\" style='cursor:pointer;vertical-align: bottom;padding: 0px 5px 2px 0px;' src='/i/social/img/icon_expand_lxp.png'></a>");
    }
};

lx.btn.ddToggle = function (pThis) {
    let $this = $(pThis);
    $(".dotBtn.open").not($this).removeClass("open");
    $this.toggleClass("open");
}

// TODO cleanup after we ditch the old app
var hightlightButton = lx.btn.hightlight;
var unhightlightButton = lx.btn.unhightlight;
var deleteHighligh = lx.btn.deleteHighlight;
var getDocBtn = lx.btn.doc;
var tree_buttons = lx.btn.tree;
